<template>
  <v-container>
    <v-row>
      <v-col class="col">
        <v-select v-model="currentSelection" label="Engagement Reward Versions"
          ref="engagementRewardVersionSelect" outlined dense hide-details return-object
          :items="reward.versions" :disabled="!value || !reward || reward.versions.length === 0 || editing">
          <template slot="selection" slot-scope="data">
            {{ getVersionDescription(data.item) }}
          </template>
          <template slot="item" slot-scope="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ getVersionDescription(data.item) }}
            </template>
          </v-select>
      </v-col>
      <v-col cols="1" class="mr-2">
        <v-btn
            color="primary"
            ref="editButton"
            class="pl-3 pr-3 mr-2 mb-1"
            @click="$emit('edit')"
            :disabled="editing || !value || !reward || reward.versions.length === 0"
        >Edit
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn
            color="primary"
            ref="createButton"
            class="pl-3 pr-3 mb-1"
            @click="$emit('create')"
            :disabled="!value || !reward || reward.versions.length === 0"
        >Create
        </v-btn>
      </v-col>
      <v-col cols="2">
        <div class="pl-3 pr-3 ml-2">
            <k-card-header-btn
              ref="backButton"
              class="pl-3 pr-3 ml-2"
              label="Back"
              icon="fa-undo"
              :click-action="onBackButton"
            />
          </div>
      </v-col>
      </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  EngagementRewardVersion, EngagementReward,
} from '@/api/engagementrewards';
import { DateTool } from '@/util';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';

@Component({
  components: {
    KCardHeader, KCardHeaderBtn,
  },
})
export default class EngagementRewardVersionSelector extends Vue {
  @Prop()
  value!: EngagementRewardVersion;

  @Prop()
  reward!: EngagementReward;

  @Prop({ default: false })
  editing!: boolean;

  currentSelection: EngagementRewardVersion | null = null;

  currentVersion: EngagementRewardVersion | null = null;

  mounted() {
    this.onValueChange();
    this.onNewReward();
  }

  @Watch('currentSelection')
  onSelectionChange() {
    this.$emit('input', this.currentSelection);
  }

  @Watch('value')
  onValueChange() {
    this.currentSelection = this.value;
  }

  @Watch('reward')
  onNewReward() {
    this.currentVersion = this.reward.getCurrentVersion();
  }

  onBackButton() {
    this.$emit('back');
  }

  getVersionDescription(version: EngagementRewardVersion) : string {
    if (!version || !version.designStartDate) {
      return '';
    }

    let startString : string = '';
    if (this.currentVersion === version) {
      startString = 'Current Reward Version';
    } else {
      startString = 'Reward Version';
    }

    const versionIndex = this.getVersionIndex(version);

    const versions = this.reward.versions;
    if (versions.length === 1 || versionIndex === 0) {
      return `${startString} - ${DateTool.toFriendlyFormatFromIsoFormatString(version.designStartDate)}`;
    }


    return `${startString} - ${DateTool.toFriendlyFormatFromIsoFormatString(version.designStartDate)} - ${DateTool.subtractOneDay(
      versions[versionIndex - 1].designStartDate,
    )}`;
  }

  getVersionIndex(version: EngagementRewardVersion) : number {
    const isEqual = (element : EngagementRewardVersion) => element === version;
    return this.reward.versions.findIndex(isEqual);
  }
}
</script>

<style lang="scss" scoped>
</style>
